import { BrandClub, CampaignType } from './Campaign';
import { RewardAmountType } from './RewardAmountType';

export type MatchedProduct = {
  retailerId: number;
  retailPrice: number;
  checkoutEligibility?: CheckoutEligibility;
  isAvailable: boolean;
  retailerProductPageUrl?: string;
  hasFirstPartyOffer: boolean;
  stacklineSku: string;
  offers?: [
    {
      updatedTime: string;
      sellerId?: string;
      sellerName?: string;
      offerId?: string;
      lastCheckedTime: string;
      availabilityStatus: 'OutOfStock' | 'InStock' | 'Unknown';
      retailPrice: number;
    },
  ];
};
export enum RewardUnlockStrategy {
  Instant = 'instant',
  // Branded Purchase will be assumed default, if missing
  BrandedPurchase = 'brandedPurchase',
}

export interface ProductReward {
  campaignStatus: string;
  campaignType: CampaignType;
  rewardAmount: number;
  rewardAmountType: RewardAmountType;
  rewardUnlockStrategy?: RewardUnlockStrategy;
  rewardPercent?: number;
}

export enum UserRewardStatus {
  Claimed = 'claimed',
  Available = 'available',
  Unavailable = 'unavailable',
}

export enum CheckoutEligibility {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  CLIENT = 'CLIENT',
  SERVER_SIDE = 'SERVER_SIDE',
}

export interface ProductRewardSearchResult {
  affiliateRewardAmount: number;
  brandId: number;
  hasActiveInstantReward: boolean;
  imageUrls: string[];
  retailerId: number;
  retailerSku: string;
  retailPrice: number;
  checkoutEligibility?: CheckoutEligibility;
  isAvailable: boolean;
  hasFirstPartyOffer: boolean;
  offers?: [
    {
      updatedTime: string;
      sellerId?: string;
      sellerName?: string;
      offerId?: string;
      lastCheckedTime: string;
      availabilityStatus: 'OutOfStock' | 'InStock' | 'Unknown';
      retailPrice: number;
    },
  ];
  stacklineSku: string;
  title: string;
  totalRewardAmount?: number;
  scores?: {
    maxPurchaseRewardPercent?: number;
    maxPurchaseRewardAmount?: number;
    maxAffiliateRewardPercent?: number;
    maxAffiliateRewardAmount?: number;
    totalReviewRewardFeesAmount?: number;
  };
  campaignRewards?: ProductReward[];
  matchedProducts?: MatchedProduct[];
  canWriteReview?: boolean;
  dtcProductPageUrl?: string;
  retailerProductPageUrl?: string;
  dtcSku?: string;
}

export type BrandClubWithPromoteCampaigns = BrandClub & {
  isMember: boolean;
  lifetimePayout: number;
  nextUnlockedRewardAmount: number;
  rewardAmount: number;
  campaignId: string;
  campaignRewards: {
    campaignId: string;
    campaignDocumentId: string;
    campaignType: string;
    campaignStatus: string;
    campaignName: string;
    createdBy: string;
    startDate: string;
    endDate: string;
    createdTime: string;
    rewardAmount: number;
    rewardCurrency: string;
    updatedBy: string;
    updatedTime: string;
    '@campaignRewardsUpdatedTime': string;
  }[];
};
